import { InvalidDTOError } from '@/api/errors/InvalidDTOError'
import { SnapshotValueDTO } from './SnapshotValueDTO'
import { SnapshotCumulativeRainfallRaw } from './SnapshotCumulativeRainfallRaw'
import { SnapshotCumulativeRainfallDTO } from './SnapshotCumulativeRainfallDTO'
import { TimeStepCumulativeRainfallDTOFactory } from './TimeStepCumulativeRainfallDTOFactory'
import { TimeStepCumulativeRainfallRaw } from './TimeStepCumulativeRainfallRaw'

export class SnapshotCumulativeRainfallDTOFactory {
  static fromRaw(raw: SnapshotCumulativeRainfallRaw): SnapshotCumulativeRainfallDTO {
    const city = raw.city
    const timestamp = raw.timestamp
    const history = raw.history
    const reference = raw.reference
    const forecasts = raw.forecasts

    const mandatoryFields = [city, timestamp, history, reference, forecasts]
    if (mandatoryFields.indexOf(null) !== -1) {
      throw new InvalidDTOError(SnapshotValueDTO.name, raw)
    }
    return new SnapshotCumulativeRainfallDTO(
      city as string,
      timestamp as string,
      history.map(TimeStepCumulativeRainfallDTOFactory.fromRaw),
      TimeStepCumulativeRainfallDTOFactory.fromRaw(reference as TimeStepCumulativeRainfallRaw),
      forecasts.map(TimeStepCumulativeRainfallDTOFactory.fromRaw),
    )
  }
}
